export enum MemberOrganizationsMutations {
  SET_ORGANIZATIONS = "SET_ORGANIZATIONS",
  SET_DEPARTMENTS = "SET_DEPARTMENTS",
}
